















































import { Vue, Component, Ref } from 'vue-property-decorator'
import store from 'src/assets/store'
import DialogFullscreen from 'components/modals/Fullscreen.vue'
import PersonSearch from 'components/account/PersonSearch.vue'
import api from 'src/assets/api/gql'
import StudentGroupCreate from 'src/graphql/student_group/StudentGroupCreate.gql'
import StudentCreate from 'src/graphql/student/StudentCreate.gql'
import { PersonPublicProfile } from 'src/graphql/types'

@Component({
  components: {
    DialogFullscreen,
    PersonSearch
  }
})
export default class ItemCourseStudentMenuButtonAdd extends Vue {
  loading = false
  name = ''

  @Ref()
  readonly dialog!: DialogFullscreen

  get item () {
    return store.state.presenter.item!
  }

  add () {
    this.name = ''
    this.dialog.show()
  }

  async addGroup (name: string) {
    this.dialog.hide()
    this.loading = true
    const { data: { createStudentGroup } } = await api.mutate({
      query: StudentGroupCreate,
      variables: {
        studentGroup: {
          courseId: this.item.id,
          name
        }
      }
    })
    this.loading = false
    if (createStudentGroup) {
      this.$emit('add-group', createStudentGroup.studentGroup)
    }
  }

  async addStudent (person: PersonPublicProfile) {
    this.dialog.hide()
    this.loading = true
    const { data: { createStudent } } = await api.mutate({
      query: StudentCreate,
      variables: {
        student: {
          courseId: this.item.id,
          personId: person.personId,
          studentGroupId: +this.$route.params.gid || null
        }
      }
    })
    this.loading = false
    if (createStudent) {
      this.$emit('add-student', createStudent.student)
    }
  }
}
